import type { PointerEvent as ReactPointerEvent } from "react";

type PointerResizeOptions = {
  axis: "x" | "y";
  cursor: "col-resize" | "row-resize";
  initialValue: number;
  minimum: number;
  maximum: number;
  onValueChange: (value: number) => void;
};

export function beginPointerResize(
  event: ReactPointerEvent<HTMLElement>,
  options: PointerResizeOptions,
) {
  event.preventDefault();
  event.currentTarget.setPointerCapture(event.pointerId);
  const start = options.axis === "x" ? event.clientX : event.clientY;
  const move = (next: PointerEvent) => {
    const coordinate = options.axis === "x" ? next.clientX : next.clientY;
    options.onValueChange(
      Math.max(
        options.minimum,
        Math.min(options.maximum, options.initialValue + start - coordinate),
      ),
    );
  };
  const stop = () => {
    window.removeEventListener("pointermove", move);
    window.removeEventListener("pointerup", stop);
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
  };
  document.body.style.cursor = options.cursor;
  document.body.style.userSelect = "none";
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", stop);
}
